"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hw_transport_1 = require("@ledgerhq/hw-transport");
exports.default = (transport) => __awaiter(void 0, void 0, void 0, function* () {
    // NB Prevents bad apdu response for LNX
    yield transport.send(0xe0, 0x50, 0x00, 0x00).catch(() => { });
    const res = yield transport.send(0xe0, 0xd2, 0x00, 0x00, Buffer.from([]), [
        hw_transport_1.StatusCodes.OK,
        hw_transport_1.StatusCodes.DEVICE_NOT_ONBOARDED,
        hw_transport_1.StatusCodes.DEVICE_NOT_ONBOARDED_2,
    ]);
    const status = res.readUInt16BE(res.length - 2);
    switch (status) {
        case hw_transport_1.StatusCodes.OK:
            return res.slice(0, res.length - 2).toString("utf-8");
        case hw_transport_1.StatusCodes.DEVICE_NOT_ONBOARDED:
        case hw_transport_1.StatusCodes.DEVICE_NOT_ONBOARDED_2:
            return "";
    }
    throw new hw_transport_1.TransportStatusError(status);
});
//# sourceMappingURL=getDeviceName.js.map